import { ZipcodePagination } from '~/definitions/zipcode';
import { getStore } from '~/mobx/AppStore';
import { ZipCodeParser } from '~/utils/zipCodeParser';

const getPaginationData = () => {
    const { zipcodeStore } = getStore();
    const expandedRanges = ZipCodeParser.getExpandedRanges(zipcodeStore.selectedZipcode).expandedRanges;
    const activeRangeId = zipcodeStore.selectedRangeId || expandedRanges[0];

    const pagination: ZipcodePagination[] = expandedRanges.map((range, index) => ({
        active: range === activeRangeId,
        page: index + 1,
        name: range,
    }));

    zipcodeStore.setPaginationData(pagination);
};

export default getPaginationData;
